module.exports = __webpack_public_path__ + "jpg/cover.jpg?a13ed7277c0e81018fef555ca554d0f9";